import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';

export const LoginPage = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(form.email, form.password); toast.success('Logged in!'); navigate('/admin'); }
    catch (e) { toast.error('Invalid credentials'); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-testid="login-page">
      <div className="w-full max-w-sm px-4">
        <div className="text-center mb-6"><Link to="/"><img src="/logo.png" alt="JustOffs" className="h-12 mx-auto" /></Link></div>
        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-sm p-6 space-y-4" data-testid="login-form">
          <h1 className="text-xl font-bold text-slate-800 text-center mb-4">Admin Login</h1>
          <div><label className="block text-sm font-medium text-slate-700 mb-1.5">Email</label><input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm" required data-testid="email-input" /></div>
          <div><label className="block text-sm font-medium text-slate-700 mb-1.5">Password</label><input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm" required data-testid="password-input" /></div>
          <button type="submit" disabled={loading} className="w-full bg-orange-500 text-white py-3 rounded-xl font-semibold hover:bg-orange-600 transition disabled:opacity-70" data-testid="login-btn">{loading ? 'Logging in...' : 'Login'}</button>
        </form>
        <p className="text-center text-slate-500 mt-4 text-sm"><Link to="/" className="text-orange-500 hover:underline">← Back to Home</Link></p>
      </div>
    </div>
  );
};
